import React from 'react';
import PropTypes from 'prop-types';
import WelcomeWidget from 'components/WelcomeWidget';
import YourPackageWidget from 'components/YourPackageWidget';
import AddressWidget from 'components/widgets/AddressWidget';
import OverviewOrdersView from 'components/OverviewOrdersView';

const OverviewView = ({
  account, nextPack, previousPack, nextDeliverablePack, nextPaymentAmount, topupsDisabledReason,
  changeUsageDisableReason, packageDetailsPath, canChangeAddress, hideChangeUsage,
}) => (
  <>
    <WelcomeWidget name={account.first_name} packageDetailsPath={packageDetailsPath} />
    <YourPackageWidget
      topupsDisabledReason={topupsDisabledReason}
      changeUsageDisableReason={changeUsageDisableReason}
      pack={nextDeliverablePack || previousPack}
      nextPaymentAmount={nextPaymentAmount}
      hideChangeUsage={hideChangeUsage}
    />
    <OverviewOrdersView
      nextPack={nextPack}
      previousPack={previousPack}
    />
    {nextDeliverablePack && <AddressWidget canChangeAddress={canChangeAddress} pack={nextDeliverablePack} />}
  </>
);

OverviewView.displayName = 'OverviewView';

OverviewView.propTypes = {
  account: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    customer_contact_details: PropTypes.shape({}),
  }).isRequired,
  nextDeliverablePack: PropTypes.shape({
    deliveryDate: PropTypes.string,
    deliveryAddress: PropTypes.shape({}),
  }),
  nextPack: PropTypes.shape({
    deliveryDate: PropTypes.string,
  }),
  previousPack: PropTypes.shape({}),
  topupsDisabledReason: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  changeUsageDisableReason: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  packageDetailsPath: PropTypes.string.isRequired,
  nextPaymentAmount: PropTypes.number.isRequired,
  canChangeAddress: PropTypes.bool,
  hideChangeUsage: PropTypes.bool,
};

OverviewView.defaultProps = {
  topupsDisabledReason: null,
  changeUsageDisableReason: null,
  nextDeliverablePack: null,
  nextPack: null,
  previousPack: null,
  canChangeAddress: false,
  hideChangeUsage: false,
};

export default OverviewView;
